{
  "version": 1,
  "asset_id": "e2c5611c-87df-451e-80c6-b5ae7fd35e54",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e2c5611c-87df-451e-80c6-b5ae7fd35e54/ind-legal-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e2c5611c-87df-451e-80c6-b5ae7fd35e54/ind-legal-1200.avif",
  "original_filename": "ind-legal-1200.avif",
  "size": 9883,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:05Z"
}
